<template>
  <div>
    <div class="ds-text-sm text-gray-700 font-normal border border-solid border-red-300 rounded bg-gray-100 py-2 px-3 mb-4" v-if="variant === 'banner'">
      <p>
        <i class="sr-2 sr-v2-exclamation-circle text-red-300 mr-1"></i>
        <span>Sending messages to college coaches is a Pro feature. </span>
        <br class="md:hidden">
        <a :href="link"
           target="_blank"
           :data-segment-tracgetDefaultDatak="linkTracking"
           data-segment-cta_name="cannot_send_messages"
           :data-segment-cta_page="ctaPage"
        >{{ linkText }} and start messaging<i class="sr-2 sr-v2-arrow-right ml-1"></i></a>
      </p>
    </div>
    
    <div v-else-if="variant === 'hero'">
      <div class="EmptyState-image col-xs-12">
        <img src=/ember_app/dist/images/empty-state_msgs-lock.svg>
      </div>
      
      <h3 class="EmptyState-message col-xs-12">Sending messages to college coaches is a Pro feature.</h3>
      
      <p class="EmptyState-action col-xs-12">
        <a :href="link"
           target="_blank"
           :data-segment-track="linkTracking"
           :data-segment-cta_name="heroLinkCtaNameTracking"
           :data-segment-cta_page="ctaPage"
        >{{ linkText }} </a>
        <span>to unlock the messaging system.</span>
      </p>
    </div>
  </div>
</template>

<script>
  import MessageComposeWarning from "@/components/BaseMessageComposeWarning";
  
  export default {
    mixins: [
      MessageComposeWarning,
    ],
    computed: {
      link() {
        return '/pricing';
      },
      linkText() {
        if (this.isUserExpired) {
          return 'Reactivate Pro';  
        }

        return 'Upgrade your account';
      },
      linkTracking() {
        if (this.isUserExpired) {
          return 'expired_cta';
        }
        
        return 'upgrade_account_cta';
      },
      heroLinkCtaNameTracking() {
        if (this.isUserExpired) {
          return 'purchase_membership';
        }
        
        return 'upgrade_account';
      }
    }
  }
</script>